<template>
  <div class="appBar component d-flex justify-center flex-column" :style="{'color': color, 'background': background}">
    <div class="d-flex justify-space-between align-item-center">
      <div v-if="isBack" class="back" @click="back">&#xe63b;</div>
      <!-- <div v-else class="func"></div> -->
      <!-- <img v-if="isBack" class="back" @click="$common.routerBack()" src="../assets/img/icon_back.png"> -->
        <!-- <img src="../assets/img/icon_back.png" alt=""> -->
      <!-- </div> -->
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="func">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'appBar',
  props: {
    color: {
      type: String,
      default: '#333'
    },
    background: {
      type: String,
      default: '#FFF'
    },
    isBack: {
      type: Boolean,
      default: true
    },
    nomenu: {
      type: Boolean,
      default: false
    },
    backNative : {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      if(this.backNative || this.$route.query.backNative) {
        this.$native.exit()
      } else {
        this.$common.routerBack()
      }
    }
    // async backRoute() {
    //   this.$common.back()
    // }
  },
  created() {
    // console.log(this.$route.query)
  }
}
</script>

<style lang="less">
.appBar.component{
  width: 100%;
  height: 50px;
  // line-height: 40px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-sizing: border-box;
  padding: 0px 8px;
  background-size: 100% auto !important;
  // text-align: c;
  // >div{
  // }
  &+*{
    padding-top: 50px;
  }
  .back{
    width: 26px;
    font-family: 'iconfont';
    font-size: 18px;
    font-weight: 600;
    img{
      width: 100%;
    }
  }
  .title{
    line-height: 1;
    flex-grow: 1;
  }
  .func{
    min-width: 26px;
    min-height: 1px;
  }
}
</style>